import { DirectusHttpError } from '@app/interfaces/directus/directus-http-error.interface';
import { DirectusService } from '../directus/directus.service';
import { HttpErrorCodes } from '@app/enums/http-error-codes.enum';
import { Injectable, inject } from '@angular/core';
import { StorageService } from '../storage/storage.service';
import { ToastService } from '../toast/toast.service';
import { filter, tap } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class HttpErrorService {
    private readonly directusService: DirectusService = inject(DirectusService);
    private readonly toastService: ToastService = inject(ToastService);
    private readonly storageService: StorageService = inject(StorageService);

    public initialize(): void {
        this.directusService.currentError
            .pipe(
                filter((error): error is DirectusHttpError => error !== null),
                tap((error: DirectusHttpError) => this.handleError(error))
            )
            .subscribe();
    }

    private async handleError(error: DirectusHttpError): Promise<void> {
        console.log('🚀 ~ HttpErrorService ~ handleError ~ error:', error);
        let customMessage = null;
        switch (error.code) {
            case HttpErrorCodes.INVALID_TOKEN:
            case HttpErrorCodes.TOKEN_EXPIRED:
                this.storageService.clear();
                break;
            case HttpErrorCodes.RECORD_NOT_UNIQUE:
                customMessage = 'toast_users_record_not_unique';
                break;
        }
        // only handle 500 errors
        if (error.status === 500) {
            this.toastService.showError('toast_internal_server_error');
        } else {
            this.toastService.showError(customMessage || error.message || 'toast_internal_server_error');
        }
    }
}

export const httpErrorServiceFactory = (httpErrorService: HttpErrorService) => {
    return (): void => httpErrorService.initialize();
};
